﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const redux_2 = require("../../redux");
class Logout extends React.Component {
    componentDidMount() {
        this.props.logout();
    }
    render() {
        return null;
    }
}
function mapDispatchToProps(dispatch) {
    return redux_1.bindActionCreators({
        logout: redux_2.SagaActions.actionCreators.triggerLogoutSaga
    }, dispatch);
}
exports.default = react_redux_1.connect(() => ({}), mapDispatchToProps)(Logout);
//# sourceMappingURL=Logout.js.map